








  import { Component, Vue } from 'vue-property-decorator';
  
@Component({
  name:"ListMedias",
  components:{}
})
export default class ListMedias extends Vue {
  private arianeItems = [
    { text: 'Administration', disabled: false, to: {name:'Admin'}, exact:true},
    { text: 'Dashboard', disabled: false, to: {name:'Dashboard'}, exact:true},
    { text: 'Medias',       disabled: true,  to: {name:'ListMedias'}}
  ]  
}
